import * as React from 'react'

import { Info } from 'app2/components'

export function HiddenWarning() {
  return <Info type='warning' mb='$16'>This activity will not be shown on the school's registration page because it is marked hidden.</Info>
}
